<template>
  <!--begin::Advance Table Widget 2-->
  <div class="card card-custom card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          List Users
        </span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          Total number of current users: {{ data.length }}
        </span>
      </h3>
      <div class="card-toolbar">
        <ul class="nav nav-pills nav-pills-sm nav-dark-75">
          <li class="nav-item mx-2">
            <b-button v-b-modal.modal-add-user variant="info">Create a user</b-button>

            <b-modal
                id="modal-add-user"
                title="Add User"
                ref="modal-add-user"
                hide-footer
                centered
                size="md"
            >
              <b-form @submit.prevent="submitFormAddUser" @reset="onReset" novalidate>
                <b-form-group
                    label="Username:"
                    label-for="input-username"
                    description="Enter the desired username."
                >
                  <b-form-input
                      id="input-username"
                      v-model.trim="form.username"
                      required
                      placeholder="Enter username"
                      autocomplete="username"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Password:"
                    label-for="input-password"
                    description="Enter a secure password."
                >
                  <b-form-input
                      id="input-password"
                      type="password"
                      v-model.trim="form.password"
                      required
                      placeholder="Enter password"
                      autocomplete="new-password"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                    label="Repeat Password:"
                    label-for="Repeat-password"
                    description="Enter a Repeat password."
                >
                  <b-form-input
                      id="Repeat-password"
                      type="password"
                      v-model.trim="form.password_confirmation"
                      required
                      placeholder="Enter Repeat password"
                      autocomplete="Repeat-password"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="IP Address:">
                  <b-form-input
                      v-model="form.ips[0]"
                      disabled
                      plaintext
                      class="bg-light text-muted"
                  ></b-form-input>
                </b-form-group>

                <!-- Buttons: all in one row, spaced -->
                <div class="d-flex justify-content-between mt-4">
                  <b-button
                      block
                      class="m-1 mt-2"
                      type="reset"
                      variant="outline-secondary"
                      @click="onReset"
                  >
                    Reset
                  </b-button>
                  <b-button
                      class="m-1 mt-2"
                      block
                      type="submit"
                      variant="primary"
                  >
                    Create
                  </b-button>

                  <b-button
                      block
                      class="m-1 mt-2"
                      variant="outline-danger"
                      @click="hideModal"
                  >
                    Close
                  </b-button>
                </div>
              </b-form>
            </b-modal>


          </li>
          <li class="nav-item mx-2">
            <b-button variant="primary" @click="getUsers" ref="kt_list_update_users">Update</b-button>
          </li>

        </ul>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body pt-3 pb-0">
      <b-modal
          id="modal-change-pass-user"
          :title="`Change User Password: ${form_change_pass.username}`"
          ref="modal-change-pass-user"
          hide-footer
          centered
          size="md"
      >
        <b-form @submit.prevent="submitFormChangePass" @reset="onReset" novalidate>
          <b-form-group
              label="New Password:"
              label-for="input-1"
              description="Enter a strong new password."
          >
            <b-form-input
                id="input-1"
                type="password"
                v-model.trim="form_change_pass.new_password"
                placeholder="Enter new password"
                required
                autocomplete="new-password"
            ></b-form-input>
          </b-form-group>

          <b-form-group
              label="Repeat Password:"
              label-for="input-2"
              description="Re-enter the password to confirm."
          >
            <b-form-input
                id="input-2"
                type="password"
                v-model.trim="form_change_pass.new_password_confirmation"
                placeholder="Repeat new password"
                required
                autocomplete="new-password"
            ></b-form-input>
          </b-form-group>

          <!-- Buttons in one horizontal line -->
          <div class="d-flex justify-content-between mt-4">
            <b-button block class="m-1 mt-2" type="reset" variant="outline-secondary" @click="onReset">
              Reset
            </b-button>
            <b-button block class="m-1 mt-2" type="submit" variant="primary">
              Change Password
            </b-button>
            <b-button block class="m-1 mt-2" variant="outline-danger" @click="hideModal">
              Close
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <b-modal
          id="modal-change-role-user"
          :title="`Change User Roles: ${form_change_role.user_id}`"
          ref="modal-change-role-user"
          hide-footer
          centered
          size="md"
      >
        <b-form @submit.prevent="submitFormChangeRole" novalidate>
          <b-form-group label="Select Roles for This User:">
            <b-form-checkbox-group
                id="checkbox-group-roles"
                v-model="form_change_role.role_ids"
                name="role-selection"
                stacked
            >
              <b-form-checkbox
                  v-for="(item, i) in role_data"
                  :key="i"
                  :value="item.id"
              >
                {{ item.name }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>

          <!-- Buttons in one row -->
          <div class="d-flex justify-content-between mt-4">
            <b-button
                variant="outline-danger"
                @click="hideModal"
            >
              Close
            </b-button>
            <b-button
                type="submit"
                variant="primary"
            >
              Save Changes
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!--begin::Table-->
      <div class="table-responsive">
        <table class="table table-hover table-bordered text-center align-middle">
          <thead class="thead-dark">
          <tr>
            <th class="fw-bold">#</th>
            <th class="fw-bold">Username</th>
            <th class="fw-bold">Roles</th>
            <th class="fw-bold">Status</th>
            <th class="fw-bold">Actions</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(item, i) in data">
            <tr :key="i">
              <td>{{ i + 1 }}</td>
              <td class="fw-semibold text-dark">{{ item.username }}</td>
              <td>
                <div v-if="item.roles.length">
            <span
                v-for="perm in item.roles"
                :key="perm.id"
                class="badge bg-warning text-dark m-1"
            >
              {{ perm.name }}
            </span>
                </div>
                <span v-else class="badge bg-danger">No Access</span>
              </td>
              <td>
                <button
                    @click="changeActiveStatus(i, item.username, item.is_active)"
                    :class="['btn btn-sm fw-bold', item.is_active ? 'btn-success' : 'btn-danger']"
                >
                  {{ item.is_active ? 'ACTIVE' : 'INACTIVE' }}
                </button>
              </td>
              <td>
          <span
              class="mr-2"
              style="cursor: pointer;"
              v-b-tooltip.hover
              title="Change Password"
              @click="showModalChangePass(item.username)"
          >
            <inline-svg src="media/svg/icons/Code/Lock-overturning.svg"></inline-svg>
          </span>
                <span
                    class="mr-2"
                    style="cursor: pointer;"
                    v-b-tooltip.hover
                    title="Edit Roles"
                    @click="showModalChangeRole(item.id)"
                >
            <inline-svg src="media/svg/icons/Communication/Write.svg"></inline-svg>
          </span>
<!--                <span-->
<!--                    class="mr-2"-->
<!--                    style="cursor: pointer;"-->
<!--                    v-b-tooltip.hover-->
<!--                    title="Delete User"-->
<!--                >-->
<!--            <inline-svg src="media/svg/icons/General/Trash.svg"></inline-svg>-->
<!--          </span>-->
              </td>
            </tr>
          </template>
          </tbody>
        </table>

      </div>
      <!--end::Table-->
    </div>
    <!--end::Body-->
    <!--end::Advance Table Widget 2-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  ADD_USERS,
  CHANGE_PASS_USER,
  CHANGE_USER_ROLE,
  CHANGE_USER_STATE,
  LIST_USERS
} from "@/core/services/store/users.module";
import {LIST_ROLES} from "@/core/services/store/roles.module";
import Swal from "sweetalert2";

export default {
  name: "table-users",
  data() {
    return {
      data: [],
      role_data: [],
      form: {
        username: '',
        password: '',
        password_confirmation: '',
        ips: ["0.0.0.0"]
      },
      form_change_pass: {
        username: "",
        new_password: "",
        new_password_confirmation: ""
      },
      form_change_role: {
        user_id: null,
        role_ids: []
      }
    };
  },
  components: {},
  methods: {
    getUsers() {
      const submitButton = this.$refs["kt_list_update_users"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      this.$store.dispatch(LIST_USERS).then((res) => {
        this.data = res
        submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
        );
      }).catch(() => {
      });
    },
    getRoles() {
      this.$store.dispatch(LIST_ROLES)
          .then((res) => {
            this.role_data = res
          })
          .catch((error) => {
            console.error("Error:", error);
          });
    },
    changeActiveStatus(i, username, status) {
      Swal.fire({
        title: "Are you sure you want to change the user status?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "YES",
        denyButtonText: `NO`
      }).then((result) => {
        if (result.isConfirmed) {
          this.data[i].is_active = !status
          let sender = {
            username: username,
            new_status: !status
          }
          this.$store.dispatch(CHANGE_USER_STATE, sender).then((res) => {
            this.getUsers();
            Swal.fire({
              icon: "success",
              title: `state user ${username} changed to ${!status}`
            });
          }).catch((err) => {
            console.error(err);
          });
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });

    },
    formatDateTime(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }) + ', ' + date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    },
    getPersianDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    },
    submitFormAddUser() {
      if (this.form.password.length < 8) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "The password must be at least 8 characters long",
        });
      } else if (this.form.password === this.form.password_confirmation) {
        this.$store.dispatch(ADD_USERS, this.form).then((res) => {
          this.getUsers();
          this.$refs['modal-add-user'].hide();
          this.reset_forms()
          Swal.fire({
            icon: "success",
            title: "User Added"
          });
        }).catch((err) => {
          console.error(err);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Passwords do not match!",
        });
      }
    },
    submitFormChangePass() {
      if (this.form_change_pass.new_password.length < 8) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "The password must be at least 8 characters long",
        });
      } else if (this.form_change_pass.new_password === this.form_change_pass.new_password_confirmation) {
        this.$store.dispatch(CHANGE_PASS_USER, this.form_change_pass).then((res) => {
          this.$refs['modal-change-pass-user'].hide()
          Swal.fire({
            icon: "success",
            title: "Password Changed"
          });
          this.reset_forms()
        }).catch((err) => {
          console.error(err);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Passwords do not match!",
        });
      }
    },
    submitFormChangeRole() {
      this.$store.dispatch(CHANGE_USER_ROLE, this.form_change_role).then((res) => {
        this.$refs['modal-change-role-user'].hide()
        Swal.fire({
          icon: "success",
          title: "Role Changed"
        });
        this.getUsers();
      }).catch((err) => {
        console.error(err);
      });
    },
    onReset(evt) {
      evt.preventDefault()
      this.reset_forms()
    },
    reset_forms() {
      this.form.username = ''
      this.form.password = ''
      this.form.password_confirmation = ''
      this.form.checked = ["0.0.0.0"]
      this.form_change_pass.new_password = ""
      this.form_change_pass.new_password_confirmation = ""
    },
    hideModal() {
      this.$refs['modal-add-user'].hide()
      this.$refs['modal-change-pass-user'].hide()
    },
    showModalChangePass(username) {
      this.form_change_pass.username = username
      this.$refs['modal-change-pass-user'].show()
    },
    showModalChangeRole(user_id) {
      this.form_change_role.user_id = user_id
      const userInfo = this.data.find(user => user.id === user_id);
      this.form_change_role.role_ids = userInfo.roles.map(role => role.id);
      this.$refs['modal-change-role-user'].show()
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
  },
  mounted() {
    this.getUsers()
    this.getRoles()
  }
};
</script>
